export class SettlementViewModel {
    patientStatementId: number;
    fundId: number;
    notes: string;
}
